import noImg from 'assets/images/noImg.jpg';
import { color } from 'styles/pallete';

export function returnThumbYoutube(
	linkVideoYoutube: string,
	title: string,
	returnUrlImg = false
): JSX.Element | string {
	const url = linkVideoYoutube || '';

	// tenta capturar o ID em diferentes formatos
	const match = url.match(
		/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([^&?/]+)/
	);

	const videoId = match ? match[1] : null;

	const thumbUrl = videoId
		? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
		: noImg;

	return returnUrlImg ? (
		thumbUrl
	) : (
		<img
			src={thumbUrl}
			style={{ backgroundColor: color.interface.lightGray2 }}
			alt={`Thumbnail de ${title || ''}`}
			onError={(e) => {
				(e.currentTarget as HTMLImageElement).src = noImg;
			}}
		/>
	);
}
